    <!--Reorder products-->                    
(function () {
    function sortAndSplitProducts(retries = 10) {
        const productsContainer = document.querySelector('ul#gf-products');
        if (!productsContainer) {
            if (retries > 0) {
                setTimeout(() => sortAndSplitProducts(retries - 1), 300);
            }
            return;
        }

        const productDivs = Array.from(productsContainer.querySelectorAll('.spf-col-xl-3.spf-col-lg-4.spf-col-md-4.spf-col-sm-4.spf-col-6'));
        if (productDivs.length === 0) {
            if (retries > 0) {
                setTimeout(() => sortAndSplitProducts(retries - 1), 300);
            }
            return;
        }

        let singleSection = document.querySelector('#single-section');
        let bundleSection = document.querySelector('#bundle-section');

        if (!singleSection) {
            singleSection = document.createElement('div');
            singleSection.id = 'single-section';
            singleSection.innerHTML = `<h2>Single</h2><ul class="product-list"></ul>`;
            productsContainer.before(singleSection);
        }

        if (!bundleSection) {
            bundleSection = document.createElement('div');
            bundleSection.id = 'bundle-section';
            bundleSection.innerHTML = `<h2>Bundles</h2><ul class="product-list"></ul>`;
            productsContainer.before(bundleSection);
        }

        const singleList = singleSection.querySelector('ul.product-list');
        const bundleList = bundleSection.querySelector('ul.product-list');

        singleList.innerHTML = '';
        bundleList.innerHTML = '';

        const singleAvailable = [];
        const singleSoldOut = [];
        const bundleAvailable = [];
        const bundleSoldOut = [];

        productDivs.forEach(product => {
            const card = product.querySelector('.spf-product-card');
            const variantField = card?.querySelector('.variant-metafield');
            const value = variantField?.textContent.trim().toLowerCase() || '';

            const isSoldOut = product.querySelector('.spf-product__label-soldout') !== null;

            console.log('Classifying product:', {
                value,
                isSoldOut,
                cardHTML: card?.innerHTML
            });

            if (value === 'single') {
                isSoldOut ? singleSoldOut.push(product) : singleAvailable.push(product);
            } else if (value === 'bundle') {
                isSoldOut ? bundleSoldOut.push(product) : bundleAvailable.push(product);
            } else {
                console.warn('Product not classified. Fallback to single section:', product);
                singleAvailable.push(product); // Optional: fallback bucket
            }
        });

        [...singleAvailable, ...singleSoldOut].forEach(product => singleList.appendChild(product));
        [...bundleAvailable, ...bundleSoldOut].forEach(product => bundleList.appendChild(product));

        function updateNoProductMessage(section, productList) {
            let message = section.querySelector('.no-product-msg');
            if (productList.children.length === 0) {
                if (!message) {
                    message = document.createElement('p');
                    message.className = 'no-product-msg';
                    message.textContent = 'No product available';
                    section.appendChild(message);
                }
            } else {
                if (message) message.remove();
            }
        }

        updateNoProductMessage(singleSection, singleList);
        updateNoProductMessage(bundleSection, bundleList);
    }

    document.addEventListener('DOMContentLoaded', () => sortAndSplitProducts());
    window.addEventListener('load', () => sortAndSplitProducts());

    document.addEventListener('click', (event) => {
        if (
            event.target.closest('.gf-option-box button') || 
            event.target.closest('.globo-selected-items li a') || 
            event.target.closest('.gf-option-block a.gf-clear') 
        ) {
            setTimeout(() => sortAndSplitProducts(), 500);
        }
    });

    const productsContainer = document.querySelector('ul#gf-products');
    if (productsContainer) {
        const observer = new MutationObserver(() => {
            setTimeout(() => sortAndSplitProducts(), 500);
        });

        observer.observe(productsContainer, { childList: true, subtree: true });
    }
})();
